import type { FaireProductEntity } from "../../entity_types/product";

export const p_gu5hb6d4wb: FaireProductEntity = {
  token: "p_gu5hb6d4wb",
  type: "product",
  name: "P.F. Candle Co. Branded Wick Trimmer",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/75390937addbea908659503ef653bf9b5645c40ca2292d05e618a371ee9be87b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bcf38f533b276d90f53c99da3cbee3957a1b7de75f06be6bde135529b3107580.png",
    "https://cdn.faire.com/fastly/f3ee0c90a441352d09566463c42b0f9cd87d6f0053e3cabc13fb2b25d748ccf2.jpeg",
    "https://cdn.faire.com/fastly/658e35bdd1d78af29f09466ec1aa29f83cf8b60e25e6054389d71f03f8f26abb.jpeg",
  ],
  priceDollars: 9,
  description:
    "Our number one pro tip for candle care 101: properly trimming your candle's wick helps to ensure product quality and longevity! These smooth matte black wick trimmers are the perfect companion to any candle collection. \n\nHeavy duty yet lightweight, they provide a clean and precise cut and catch excess trimmings for disposal. Enjoy your favorite P.F. fragrance to its fullest with our sleek new candle companion! \n\nHow to use your wick trimmer:\n- Make sure to trim your wick before each lighting or once your candle has cooled to room temperature; never attempt to trim a burning candle. \n- Place the trimmer's long handle against the inside of the jar's rim for guidance and bring the curved scissor blades to the wick, about 1/4\" from the base and parallel with the wax. \n- Trim your wick and discard the snipped portion in the trash. As a safety precaution, never leave wick trimmings (matches or other debris, for that matter) in your candle jar!",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:58.023Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
